import { FC } from "react";
import { ChequeCounterProps } from "./types";
import { Row, ScrollRow } from "../../../../components/containers";
import { JustifyContent } from "../../../../components/containers/types";
import { Text } from "../../../../components/typography";
import { useThemeStore } from "../../../../stores";

const ChequeCounter: FC<ChequeCounterProps> = ({
  nrCheques,
  selectedChequeIdx,
  setSelectedChequeIdx,
  props,
  className = "",
  style = {},
}) => {
  const theme = useThemeStore((s) => s.theme);
  return (
    <ScrollRow
      reverse
      gap={10}
      height={50}
      style={style}
      props={props}
      className={className}
    >
      {[...Array(nrCheques)].map((_, idx) => (
        <Row
          key={idx}
          justifyContent={JustifyContent.Center}
          style={{ cursor: "pointer", padding: "0 5px" }}
          props={{ onClick: () => setSelectedChequeIdx(idx) }}
        >
          <Text
            size={20}
            color={
              selectedChequeIdx === idx ? theme.primary : theme.textOnOverlay
            }
            className="transition"
          >
            {String(idx + 1)}
          </Text>
        </Row>
      ))}
    </ScrollRow>
  );
};

export default ChequeCounter;
